<template>
  <div class="content">
    <div class="row">
      <div class="col-8 ignore-screen">
        <h2 class="font-light">Edit Scanned Record</h2>
      </div>
      <div class="col-4 ignore-screen u-vertical-center u-inline-flex">
        <div class="form-group u-inline u-fill-width u-text-right">
          <back-button></back-button>
        </div>
      </div>
    </div>
    <server-error v-bind:error="error.serverError"></server-error>
    <scanned-record-form
      v-bind:data="scannedRecord"
      v-on:input="updateForm"
    ></scanned-record-form>
  </div>
</template>

<style>
input[type="file"] {
    display: none;
}
</style>
/
<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import ScannedRecordForm from "@/components/records/ScannedRecordForm";
import BackButton from "@/components/BackButton";
import ServerError from "@/components/ServerError";
import { scrollToTop } from "@/functions/scrollToTop";

export default {
  name: "scanned-record-create",
  components: {
    ScannedRecordForm,
    BackButton,
    ServerError,
  },
  computed: {
    ...mapGetters("auth", ["users", "userProfile", "permissions"]),
    ...mapGetters("core", ["error"]),
    ...mapGetters("records", ["getScannedRecord"]),
    scannedRecord: function() {
      return this.getScannedRecord(this.$route.params.id);
    }
  },
  methods: {
    updateForm: function(key, value) {
      Vue.set(this.scannedRecord, key, value);
    }
  },
  mounted() {
    scrollToTop();
  },
}
</script>
